/**
 * @fileoverview gRPC-Web generated client stub for tprmquestionnaire
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: tprmquestionnaire/vendor_questionnaire_received.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var tprmquestionnaire_questionnaire_internal_pb = require('../tprmquestionnaire/questionnaire_internal_pb.js')

var tprmquestionnaire_tprmquestionnaire_pb = require('../tprmquestionnaire/tprmquestionnaire_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.tprmquestionnaire = require('./vendor_questionnaire_received_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest,
 *   !proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse>}
 */
const methodDescriptor_VendorQuestionnaireReceivedService_ListReceivedVendorQuestionnaires = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.VendorQuestionnaireReceivedService/ListReceivedVendorQuestionnaires',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest,
  proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse,
  /**
   * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServiceClient.prototype.listReceivedVendorQuestionnaires =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/ListReceivedVendorQuestionnaires',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_ListReceivedVendorQuestionnaires,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnairesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ListReceivedVendorQuestionnairesResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServicePromiseClient.prototype.listReceivedVendorQuestionnaires =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/ListReceivedVendorQuestionnaires',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_ListReceivedVendorQuestionnaires);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest,
 *   !proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse>}
 */
const methodDescriptor_VendorQuestionnaireReceivedService_GetReceivedVendorQuestionnaire = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.VendorQuestionnaireReceivedService/GetReceivedVendorQuestionnaire',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest,
  proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse,
  /**
   * @param {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServiceClient.prototype.getReceivedVendorQuestionnaire =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/GetReceivedVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_GetReceivedVendorQuestionnaire,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServicePromiseClient.prototype.getReceivedVendorQuestionnaire =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/GetReceivedVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_GetReceivedVendorQuestionnaire);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest,
 *   !proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse>}
 */
const methodDescriptor_VendorQuestionnaireReceivedService_UpdateReceivedVendorQuestionnaire = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.VendorQuestionnaireReceivedService/UpdateReceivedVendorQuestionnaire',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest,
  proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse,
  /**
   * @param {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServiceClient.prototype.updateReceivedVendorQuestionnaire =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/UpdateReceivedVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_UpdateReceivedVendorQuestionnaire,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.UpdateReceivedVendorQuestionnaireResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServicePromiseClient.prototype.updateReceivedVendorQuestionnaire =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/UpdateReceivedVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_UpdateReceivedVendorQuestionnaire);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.EditImportedQuestionnaireRequest,
 *   !proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse>}
 */
const methodDescriptor_VendorQuestionnaireReceivedService_EditImportedQuestionnaire = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.VendorQuestionnaireReceivedService/EditImportedQuestionnaire',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.EditImportedQuestionnaireRequest,
  proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse,
  /**
   * @param {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServiceClient.prototype.editImportedQuestionnaire =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/EditImportedQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_EditImportedQuestionnaire,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.EditImportedQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServicePromiseClient.prototype.editImportedQuestionnaire =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/EditImportedQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_EditImportedQuestionnaire);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest,
 *   !proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse>}
 */
const methodDescriptor_VendorQuestionnaireReceivedService_SaveReceivedVendorAnswer = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.VendorQuestionnaireReceivedService/SaveReceivedVendorAnswer',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest,
  proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse,
  /**
   * @param {!proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServiceClient.prototype.saveReceivedVendorAnswer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/SaveReceivedVendorAnswer',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_SaveReceivedVendorAnswer,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.SaveReceivedVendorAnswerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.SaveReceivedVendorAnswerResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServicePromiseClient.prototype.saveReceivedVendorAnswer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/SaveReceivedVendorAnswer',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_SaveReceivedVendorAnswer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.MarkReceivedVendorAnswerReviewedRequest,
 *   !proto.tprmquestionnaire.MarkReceivedVendorAnswerReviewedResponse>}
 */
const methodDescriptor_VendorQuestionnaireReceivedService_MarkReceivedVendorAnswerReviewed = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.VendorQuestionnaireReceivedService/MarkReceivedVendorAnswerReviewed',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.MarkReceivedVendorAnswerReviewedRequest,
  proto.tprmquestionnaire.MarkReceivedVendorAnswerReviewedResponse,
  /**
   * @param {!proto.tprmquestionnaire.MarkReceivedVendorAnswerReviewedRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.MarkReceivedVendorAnswerReviewedResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.MarkReceivedVendorAnswerReviewedRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.MarkReceivedVendorAnswerReviewedResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.MarkReceivedVendorAnswerReviewedResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServiceClient.prototype.markReceivedVendorAnswerReviewed =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/MarkReceivedVendorAnswerReviewed',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_MarkReceivedVendorAnswerReviewed,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.MarkReceivedVendorAnswerReviewedRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.MarkReceivedVendorAnswerReviewedResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServicePromiseClient.prototype.markReceivedVendorAnswerReviewed =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/MarkReceivedVendorAnswerReviewed',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_MarkReceivedVendorAnswerReviewed);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireRequest,
 *   !proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireResponse>}
 */
const methodDescriptor_VendorQuestionnaireReceivedService_DeleteReceivedVendorQuestionnaire = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.VendorQuestionnaireReceivedService/DeleteReceivedVendorQuestionnaire',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireRequest,
  proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireResponse,
  /**
   * @param {!proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServiceClient.prototype.deleteReceivedVendorQuestionnaire =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/DeleteReceivedVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_DeleteReceivedVendorQuestionnaire,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServicePromiseClient.prototype.deleteReceivedVendorQuestionnaire =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/DeleteReceivedVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_DeleteReceivedVendorQuestionnaire);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest,
 *   !proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse>}
 */
const methodDescriptor_VendorQuestionnaireReceivedService_SubmitReceivedVendorQuestionnaire = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.VendorQuestionnaireReceivedService/SubmitReceivedVendorQuestionnaire',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest,
  proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse,
  /**
   * @param {!proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServiceClient.prototype.submitReceivedVendorQuestionnaire =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/SubmitReceivedVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_SubmitReceivedVendorQuestionnaire,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.SubmitReceivedVendorQuestionnaireResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServicePromiseClient.prototype.submitReceivedVendorQuestionnaire =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/SubmitReceivedVendorQuestionnaire',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_SubmitReceivedVendorQuestionnaire);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest,
 *   !proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse>}
 */
const methodDescriptor_VendorQuestionnaireReceivedService_ListReceivedVendorQuestionnaireVersions = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.VendorQuestionnaireReceivedService/ListReceivedVendorQuestionnaireVersions',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest,
  proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse,
  /**
   * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServiceClient.prototype.listReceivedVendorQuestionnaireVersions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/ListReceivedVendorQuestionnaireVersions',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_ListReceivedVendorQuestionnaireVersions,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireVersionsResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServicePromiseClient.prototype.listReceivedVendorQuestionnaireVersions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/ListReceivedVendorQuestionnaireVersions',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_ListReceivedVendorQuestionnaireVersions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest,
 *   !proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse>}
 */
const methodDescriptor_VendorQuestionnaireReceivedService_GetReceivedVendorQuestionnaireVersion = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.VendorQuestionnaireReceivedService/GetReceivedVendorQuestionnaireVersion',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest,
  proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse,
  /**
   * @param {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServiceClient.prototype.getReceivedVendorQuestionnaireVersion =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/GetReceivedVendorQuestionnaireVersion',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_GetReceivedVendorQuestionnaireVersion,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.GetReceivedVendorQuestionnaireVersionResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServicePromiseClient.prototype.getReceivedVendorQuestionnaireVersion =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/GetReceivedVendorQuestionnaireVersion',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_GetReceivedVendorQuestionnaireVersion);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest,
 *   !proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment>}
 */
const methodDescriptor_VendorQuestionnaireReceivedService_CreateReceivedVendorQuestionnaireComment = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.VendorQuestionnaireReceivedService/CreateReceivedVendorQuestionnaireComment',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest,
  proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment,
  /**
   * @param {!proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServiceClient.prototype.createReceivedVendorQuestionnaireComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/CreateReceivedVendorQuestionnaireComment',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_CreateReceivedVendorQuestionnaireComment,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.CreateReceivedVendorQuestionnaireCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ReceivedVendorQuestionnaireComment>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServicePromiseClient.prototype.createReceivedVendorQuestionnaireComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/CreateReceivedVendorQuestionnaireComment',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_CreateReceivedVendorQuestionnaireComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest,
 *   !proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse>}
 */
const methodDescriptor_VendorQuestionnaireReceivedService_ListReceivedVendorQuestionnaireComments = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.VendorQuestionnaireReceivedService/ListReceivedVendorQuestionnaireComments',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest,
  proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse,
  /**
   * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServiceClient.prototype.listReceivedVendorQuestionnaireComments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/ListReceivedVendorQuestionnaireComments',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_ListReceivedVendorQuestionnaireComments,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireCommentsResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServicePromiseClient.prototype.listReceivedVendorQuestionnaireComments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/ListReceivedVendorQuestionnaireComments',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_ListReceivedVendorQuestionnaireComments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest,
 *   !proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse>}
 */
const methodDescriptor_VendorQuestionnaireReceivedService_DeleteReceivedVendorQuestionnaireComment = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.VendorQuestionnaireReceivedService/DeleteReceivedVendorQuestionnaireComment',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest,
  proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse,
  /**
   * @param {!proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServiceClient.prototype.deleteReceivedVendorQuestionnaireComment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/DeleteReceivedVendorQuestionnaireComment',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_DeleteReceivedVendorQuestionnaireComment,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.DeleteReceivedVendorQuestionnaireCommentResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServicePromiseClient.prototype.deleteReceivedVendorQuestionnaireComment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/DeleteReceivedVendorQuestionnaireComment',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_DeleteReceivedVendorQuestionnaireComment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest,
 *   !proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse>}
 */
const methodDescriptor_VendorQuestionnaireReceivedService_MarkReceivedVendorQuestionnaireCommentsRead = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.VendorQuestionnaireReceivedService/MarkReceivedVendorQuestionnaireCommentsRead',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest,
  proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse,
  /**
   * @param {!proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServiceClient.prototype.markReceivedVendorQuestionnaireCommentsRead =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/MarkReceivedVendorQuestionnaireCommentsRead',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_MarkReceivedVendorQuestionnaireCommentsRead,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.MarkReceivedVendorQuestionnaireCommentsReadResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServicePromiseClient.prototype.markReceivedVendorQuestionnaireCommentsRead =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/MarkReceivedVendorQuestionnaireCommentsRead',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_MarkReceivedVendorQuestionnaireCommentsRead);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest,
 *   !proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse>}
 */
const methodDescriptor_VendorQuestionnaireReceivedService_UploadReceivedVendorAnswerAttachment = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.VendorQuestionnaireReceivedService/UploadReceivedVendorAnswerAttachment',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest,
  proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse,
  /**
   * @param {!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServiceClient.prototype.uploadReceivedVendorAnswerAttachment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/UploadReceivedVendorAnswerAttachment',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_UploadReceivedVendorAnswerAttachment,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.UploadReceivedVendorAnswerAttachmentResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServicePromiseClient.prototype.uploadReceivedVendorAnswerAttachment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/UploadReceivedVendorAnswerAttachment',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_UploadReceivedVendorAnswerAttachment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest,
 *   !proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse>}
 */
const methodDescriptor_VendorQuestionnaireReceivedService_DeleteReceivedVendorAnswerAttachment = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.VendorQuestionnaireReceivedService/DeleteReceivedVendorAnswerAttachment',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest,
  proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse,
  /**
   * @param {!proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServiceClient.prototype.deleteReceivedVendorAnswerAttachment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/DeleteReceivedVendorAnswerAttachment',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_DeleteReceivedVendorAnswerAttachment,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.DeleteReceivedVendorAnswerAttachmentResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServicePromiseClient.prototype.deleteReceivedVendorAnswerAttachment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/DeleteReceivedVendorAnswerAttachment',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_DeleteReceivedVendorAnswerAttachment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest,
 *   !proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse>}
 */
const methodDescriptor_VendorQuestionnaireReceivedService_ListReceivedVendorQuestionnaireAttachments = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.VendorQuestionnaireReceivedService/ListReceivedVendorQuestionnaireAttachments',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest,
  proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse,
  /**
   * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServiceClient.prototype.listReceivedVendorQuestionnaireAttachments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/ListReceivedVendorQuestionnaireAttachments',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_ListReceivedVendorQuestionnaireAttachments,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.ListReceivedVendorQuestionnaireAttachmentsResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServicePromiseClient.prototype.listReceivedVendorQuestionnaireAttachments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/ListReceivedVendorQuestionnaireAttachments',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_ListReceivedVendorQuestionnaireAttachments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest,
 *   !proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse>}
 */
const methodDescriptor_VendorQuestionnaireReceivedService_DownloadReceivedVendorAnswerAttachment = new grpc.web.MethodDescriptor(
  '/tprmquestionnaire.VendorQuestionnaireReceivedService/DownloadReceivedVendorAnswerAttachment',
  grpc.web.MethodType.UNARY,
  proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest,
  proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse,
  /**
   * @param {!proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse.deserializeBinary
);


/**
 * @param {!proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServiceClient.prototype.downloadReceivedVendorAnswerAttachment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/DownloadReceivedVendorAnswerAttachment',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_DownloadReceivedVendorAnswerAttachment,
      callback);
};


/**
 * @param {!proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.tprmquestionnaire.DownloadReceivedVendorAnswerAttachmentResponse>}
 *     Promise that resolves to the response
 */
proto.tprmquestionnaire.VendorQuestionnaireReceivedServicePromiseClient.prototype.downloadReceivedVendorAnswerAttachment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/tprmquestionnaire.VendorQuestionnaireReceivedService/DownloadReceivedVendorAnswerAttachment',
      request,
      metadata || {},
      methodDescriptor_VendorQuestionnaireReceivedService_DownloadReceivedVendorAnswerAttachment);
};


module.exports = proto.tprmquestionnaire;

